module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "login"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入账号"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verificationCode),
      expression: "verificationCode"
    }],
    staticStyle: {
      "width": "65%",
      "margin-right": "5%"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.verificationCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.verificationCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "25%",
      "vertical-align": "top"
    },
    attrs: {
      "title": "点击更换",
      "id": "refreshCodeId",
      "onclick": "$(this).attr('src', '/imageServlet?t=' + Math.random());",
      "src": "/imageServlet?t=0.8820587174216004"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "am-fr",
    staticStyle: {
      "margin-top": "-13px"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'zcgl',
        params: {
          nr: 'updPassword'
        }
      }
    }
  }, [_vm._v("忘记密码?")])], 1), _vm._v(" "), _c('button', {
    staticStyle: {
      "margin-top": "-5px"
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v("登录")]), _vm._v(" "), _c('p', [_vm._v("没有账号？"), _c('span', [_c('router-link', {
    attrs: {
      "to": {
        name: 'zcgl',
        params: {
          nr: 'register'
        }
      }
    }
  }, [_vm._v("立即注册")])], 1)])]), _vm._v(" "), _c('alert', {
    attrs: {
      "showModal": _vm.showAlert
    },
    on: {
      "update:showModal": function($event) {
        _vm.showAlert = $event
      },
      "update:show-modal": function($event) {
        _vm.showAlert = $event
      }
    }
  }, [_vm._v(_vm._s(_vm.alertMessage))]), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top"
  }, [_c('i', {
    staticClass: "iconfont icon-denglu"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "am-modal am-modal-confirm",
    attrs: {
      "tabindex": "-1",
      "id": "my-confirm"
    }
  }, [_c('div', {
    staticClass: "am-modal-dialog dh-dialog"
  }, [_c('div', {
    staticClass: "am-modal-hd"
  }, [_vm._v("重要提示")]), _vm._v(" "), _c('div', {
    staticClass: "am-modal-bd"
  }, [_c('p', [_vm._v("在继续浏览本页面前，请您细阅此重要提示，并向下滚动至本页结尾根据您的具体情况进行选择。")]), _vm._v(" "), _c('p', [_vm._v("\n          在继续浏览本页面前，请您确认您或您所代表的机构是一名\"合格投资者\"。\"合格投资者\"指根据中国证券监督管理委员会发布的《私募投资基金监督管理暂行办法》所定义的具备相应风险识别能力和风险承担能力，投资于单只私募基金的金额不低于100万元，且符合下列标准的单位和个人：")]), _vm._v(" "), _c('p', [_vm._v("（一）净资产不低于1000万元的单位；")]), _vm._v(" "), _c('p', [_vm._v("（二）金融资产不低于300万元或近三年个人年均收入不低于50万元的个人。")]), _vm._v(" "), _c('p', [_vm._v("上述金融资产包括银行存款、股票、债券、基金份额、资产管理计划、银行理财产品、信托计划、保险产品、期货权益等。")]), _vm._v(" "), _c('p', [_vm._v("下列投资者视为合格投资者：")]), _vm._v(" "), _c('p', [_vm._v("（一）社会保障基金、企业年金等养老基金，慈善基金等社会公益基金；")]), _vm._v(" "), _c('p', [_vm._v("（二）依法设立并在基金业协会备案的投资计划；")]), _vm._v(" "), _c('p', [_vm._v("（三）投资于所管理私募基金的私募基金管理人及其从业人员；")]), _vm._v(" "), _c('p', [_vm._v("（四）中国证监会规定的其他投资者。")]), _vm._v(" "), _c('p', [_vm._v("您若继续阅览本网页所载资料，将被视为您声明及保证为“合格投资者”，并将遵守中国的有关法例及法规。")]), _vm._v(" "), _c('p', [_vm._v("本网站所载的资料仅供参考，并不构成广告或分销、销售要约，或招揽买入任何证券、基金或其他投资工具的邀请或要约。")]), _vm._v(" "), _c('p', [_vm._v("\n          投资涉及风险，投资者应详细审阅基金的发售文件以获取进一步资料及了解有关投资于私募基金所涉及的风险因素，并寻求适当的专业投资和税务咨询意见。基金份额净值及其收益可升可跌，而过往的基金表现数据并不代表基金未来的表现。 本网站所提供的资料不构成投资建议或税务咨询意见，投资者不应依赖本网站所提供的资料作出投资决策。")]), _vm._v(" "), _c('p', [_vm._v("\n          东航期货有限责任公司或其关联公司不对本网站所提供资料的准确性、充足性或完整性作出任何保证，也不对于本网站内所提供资料之任何错误或遗漏承担任何法律责任。您在任何情况下均不得复印、复制或再分发本网站资料的全部或其任何部分。")]), _vm._v(" "), _c('p', [_vm._v("\n          本网站所刊载的所有资料东航期货有限责任公司可予以更改或修订而不必提前通知，东航期货有限责任公司并不承诺定期更新本网页。与本网站所载资料有关的所有版权、专利权、知识产权及其他产权均为东航期货有限责任公司或其关联公司所有。本公司概不向浏览该资料的人士发出、转让或以任何方式转移任何种类的权利。")])]), _vm._v(" "), _c('div', {
    staticClass: "am-modal-footer"
  }, [_c('span', {
    staticClass: "am-modal-btn",
    attrs: {
      "data-am-modal-confirm": ""
    }
  }, [_vm._v("我接受")]), _vm._v(" "), _c('span', {
    staticClass: "am-modal-btn",
    attrs: {
      "data-am-modal-cancel": ""
    }
  }, [_vm._v("我不接受")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11eadfe0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/zcgl/page/login.vue
// module id = 804
// module chunks = 2